import React from "react";
import moment from "moment";

export const InfoRow = (props) => {
  // CONVERT URL'S TO LINKS
  let value = props.value;
  var formats = [moment.ISO_8601, "YYYY-MM-DDZ"];
  const infoRowStyle = window.config.infoRowStyle !== undefined ? window.config.infoRowStyle.toLowerCase() : "Default";

  const isValidURL = (url) => {
    try {
      new URL(url,window.location.href);
      console.log("url IS VALID", url);
      if (url.length === 0) {
        console.log("url IS EMPTY", url);
        return false;
      } 
      console.log(typeof(url),url.length);
      return true;
    } catch (e) {
      console.log("url IS NOT VALID", url);
      return false;
    }
  };
  if (props.value != null && (props.field === "obrazok" || props.value.toString().substring(0, 4).toUpperCase() === "HTTP" || props.value.toString().substring(0, 2).toUpperCase() === "\\\\")) {
    if (isValidURL(props.value)) {
      if (props.value.match(/\.(jpeg|jpg|gif|png)$/) != null) { // Overenie, či URL je obrázok
        value = (
          <a href={props.value} target="_blank" rel="noopener noreferrer">
            <img src={props.value} alt="Odkaz na obrázok" style={{ width: '85%', height: 'auto' }} />
          </a>
        );
      } else {
        value = (
          <a href={props.value} target="_blank" rel="noopener noreferrer">
            Otvoriť obrázok
          </a>
        );
      }
    } else {
      value = "Chybný alebo chýbajúci odkaz";
    }
  } else if (props.value != null && props.value.length >= 8 && moment(props.value, formats, true).isValid()) {
    value = moment(props.value).format("YYYY-MM-DD");
  }

  return (
    <div className="sc-info-window-row">
      <div className={infoRowStyle === "table" ? "sc-info-window-label-table" : "sc-info-window-label"}>
        <div dangerouslySetInnerHTML={{ __html: props.label }} />
      </div>
      <div className={props.imageData ? "sc-hidden" : infoRowStyle === "table" ? "sc-info-window-value-table" : "sc-info-window-value"}>
        {React.isValidElement(value) ? value : <div dangerouslySetInnerHTML={{ __html: value }} />}
        {props.children}
      </div>
    </div>
  );
};

export default InfoRow;

export const InfoRowValue = (props) => {
  return (
    <div
      className={"sc-info-window-value " + props.className}
      onClick={() => {
        props.onClick(props.feature);
      }}
    >
      {props.value}
      {props.children}{" "}
    </div>
  );
};
